module.exports = __webpack_public_path__ + "img/trade-swiper-1.654ff27b.png";